import PlainTextCell from 'components/PlainTextCell';
import HighlightText from 'components/HighlightedText';
import { useSearchContext } from 'contexts/SearchContext';

type Props = {
  rowData: Pick<SentinelTeam, 'scheduledForDeletionAt'> & {
    owner?: Pick<NonNullable<SentinelTeam['owner']>, 'email'>;
  };
};

export default function OwnerEmailCell({
  rowData: { owner, scheduledForDeletionAt },
}: Props) {
  const { searchString } = useSearchContext();

  return (
    <PlainTextCell
      color={scheduledForDeletionAt ? 'alaskanHusky' : undefined}
      topLine={
        owner?.email ? (
          <HighlightText text={owner.email} searchText={searchString} />
        ) : undefined
      }
    />
  );
}
